import { produce } from 'immer'
import {
  GET_USER_SAVED_FILTERS_FAILURE,
  GET_USER_SAVED_FILTERS_SUCCESS,
  GetUserSavedFiltersActions,
} from 'src/app/ExpensesTransactions/redux/expensesTransactions.actions'
import { UserSavedFiltersResponse } from 'src/models/userSavedFilters.models'
import { ErrorDetailMap, parseBackendErrors } from 'src/utils/error.utils'

export interface UserSavedFiltersState {
  listResponses: Record<string, UserSavedFiltersResponse>
  topLevelError?: string
  errorDetailMap?: ErrorDetailMap<string>
}

export const initialState: UserSavedFiltersState = {
  listResponses: {},
}

export type Actions = GetUserSavedFiltersActions

const UserSavedFiltersReducer = (
  state: UserSavedFiltersState = initialState,
  action: Actions,
): UserSavedFiltersState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_USER_SAVED_FILTERS_SUCCESS: {
        draft.listResponses = action.payload.savedFilters.reduce(
          (acc, curr) => ({
            ...acc,
            [curr.id]: curr,
          }),
          draft.listResponses,
        )
        return draft
      }

      case GET_USER_SAVED_FILTERS_FAILURE: {
        const errors = parseBackendErrors(action.payload)
        draft.errorDetailMap = errors?.errorDetailMap
        draft.topLevelError =
          errors?.errorDetailMap === undefined
            ? action.payload?.details?.[0]?.error || errors?.topLevelError
            : errors?.topLevelError
        return draft
      }
    }
  })
}

export default UserSavedFiltersReducer
